import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useEntityFilter } from '../../../contexts/entityFilterContext';
import { PopupContainer } from '../PopupContainer';
import { EntityList } from './EntityList';

interface Props {
  onClose: () => void;
  entityOptions?: { value: string | undefined; label: string }[];
  setSelectedEntityLabel: (value: string | undefined) => void;
}

export const GlobalEntityPickerPopup: FC<Props> = ({
  onClose,
  entityOptions = [],
  setSelectedEntityLabel,
}) => {
  const { t } = useTranslation(['common']);
  const { entityIds, setEntityIds } = useEntityFilter();

  // Default entity options if none provided
  const defaultOptions = [
    { label: t('entity.global', 'Global'), value: undefined },
  ];

  const availableOptions =
    entityOptions.length > 0 ? entityOptions : defaultOptions;

  const handleEntitySelect = (selectedValue: string | undefined) => {
    setEntityIds(selectedValue ? [selectedValue] : []);

    const selectedValueLabel = availableOptions.find(
      (option) => option.value === selectedValue
    )?.label;

    setSelectedEntityLabel(selectedValueLabel);

    onClose();
  };

  return (
    <PopupContainer>
      <EntityList
        options={availableOptions}
        selectedValue={entityIds?.[0]}
        onSelect={handleEntitySelect}
      />
    </PopupContainer>
  );
};
